module.exports = __webpack_public_path__ + "files/8591e6967795f9eb86330e0f0bb5b801.png";